

export const Types = {
    UPDATE_PAGINATION: "UPDATE_PAGINATION",
    UPDATE_PAGINATION_REMOVE_OLD: "UPDATE_PAGINATION_REMOVE_OLD",
    UPDATE_FILTER: "UPDATE_FILTER",
    CLEAR_PAGINATION: "CLEAR_PAGINATION",
    CLEAR_PAGINATION_EXCEPT_ME : "CLEAR_PAGINATION_EXCEPT_ME"
  };
  